const Subsets = {
    PCEPCourseAtIar: 'PCEP Course',
    AdditionalTopicsInMath: 'Additional Topics in Math',
    PassportToAdvancedMath: 'Passport to Advanced Math',
    ProblemSolvingAndDataAnalysis: 'Problem Solving and Data Analysis',
    HeartOfAlgebra: 'Heart of Algebra',
    JavascriptQuickGuides: 'JavaScript Quick Guides',
    ReactQuickGuides: 'React Quick Guides'
}

export default Subsets